import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { Permission } from "~/hooks/permissions";
import TabsPage from "~/components/layout/TabsPage";
import TabApiKeys from "./TabApiKeys";
import TabFhirServers from "./TabFhirServers";
import TabWebhooks from "./TabWebhooks";

const IntegrationsConfig = () => {
  const { loading } = useOrgConfig();

  return <TabsPage basePath="integrations" loading={loading} tabs={{
    'api-keys': {
      label: 'Api Keys',
      permission: Permission.manageApiKeys,
      component: () => <TabApiKeys />,
    },
    'fhir-servers': {
      label: 'FHIR Servers',
      permission: Permission.debugApps,
      component: (id) => <TabFhirServers id={id} />,
    },
    'webhooks': {
      label: 'Webhooks',
      permission: Permission.manageApiKeys,
      component: () => <TabWebhooks />,
    },
  }}/>
}

export default IntegrationsConfig;
